import { render, staticRenderFns } from "./ExpressDetail.vue?vue&type=template&id=5eb55888&scoped=true"
import script from "./ExpressDetail.vue?vue&type=script&lang=js"
export * from "./ExpressDetail.vue?vue&type=script&lang=js"
import style0 from "./ExpressDetail.vue?vue&type=style&index=0&id=5eb55888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb55888",
  null
  
)

export default component.exports